import React, { useEffect, useState } from "react";
import { loadMatches, confirmMatch, markMatchAsPractice } from "../../actions";
import { MatchData, MatchScore } from "../../types";
import { getScore, getMatchStatus } from "./matchFunctions";
import cx from "classnames";
import moment from "moment";
import InfiniteLoader from "../infiniteLoader";

function scoreDisplay(myScore, otherScore) {
	return myScore.map((points, index) => {
		const otherPoints = otherScore[index];
		const className = cx({ higher: points > otherPoints });

		return (
			<div className={className} key={index}>
				{points}
			</div>
		);
	});
}

const Match = ({
	match,
	confirmMatchClick,
	markMatchAsPracticeClick,
	onSelect,
}: {
	match: MatchData;
	confirmMatchClick: any;
	markMatchAsPracticeClick: any;
	onSelect: any;
}) => {
	const me = match.createdBy === match.playerA.userId ? match.playerA : match.playerB;
	const otherPlayer = match.createdBy !== match.playerA.userId ? match.playerA : match.playerB;

	const className = cx({ practice: match.practice, confirmed: match.confirmed, disputed: match.disputed });

	const myScore = getScore(me.userId, match.score).score;
	const otherScore = getScore(otherPlayer ? otherPlayer.userId : null, match.score).score;

	return (
		<div key={match.uuid} className={className} onClick={() => onSelect(match)}>
			{moment.unix(match.date).format("LL")}
			{getMatchStatus(match.winnerId, me.userId)}
			{match.club.clubInfo.name} <br />
			{me.firstName} {me.lastName}
			{scoreDisplay(myScore, otherScore)}
			<br />
			{otherPlayer ? (
				<div>
					{otherPlayer.firstName} {otherPlayer.lastName} <br />
					{scoreDisplay(otherScore, myScore)}
				</div>
			) : null}
			{match.pictures.map((picture) => {
				return <img src={picture.thumbnailUrl} />;
			})}
			<div>{!match.confirmed ? <div onClick={() => confirmMatchClick(match)}>confirm</div> : null}</div>
			<div>
				{!match.practice ? <div onClick={() => markMatchAsPracticeClick(match)}>mark as practice</div> : null}
			</div>
		</div>
	);
};

const MatchList = ({ limit = 10, onSelect }) => {
	const [matches, updateMatches] = useState([] as MatchData[]);
	const [currentPage, setPage] = useState(0);

	useEffect(() => {
		loadMatches(limit, currentPage).then((res: any) => {
			updateMatches([...res.data.concat(matches)]);
		});
	}, [currentPage]);

	const onViewChange = async (inView: boolean, observerEntry) => {
		const shouldLoad = inView;

		if (shouldLoad) {
			console.log("laoding page", currentPage);
			setPage(currentPage + 1);
		}
	};

	const confirmMatchClick = async (match: MatchData) => {
		const res = await confirmMatch(match.uuid);
		console.log({ res });
	};

	const markMatchAsPracticeClick = async (match: MatchData) => {
		const res = markMatchAsPractice(match.uuid);
		console.log({ res });
	};

	return (
		<div>
			<h1 className="h2">Match list</h1>

			{matches.map((match) => {
				return (
					<Match
						match={match}
						confirmMatchClick={confirmMatchClick}
						markMatchAsPracticeClick={markMatchAsPracticeClick}
						onSelect={onSelect}
					/>
				);
			})}

			<InfiniteLoader onViewChange={onViewChange} />
		</div>
	);
};

export default MatchList;
